import { JOBS_ENDPOINT } from "../config";
import { createInstance } from "./createInstance";
const instance = createInstance(JOBS_ENDPOINT);
export default instance;
